import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ToastModal from "views/components/ToastModal";

const NoticeBoard = () => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "id", label: "Id" },
    { id: "name", label: "Name" },
    { id: "action", label: "Actions" },
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [noticeId, setNoticeId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [rawData, setRawData] = useState([]);

  // submit create function
  const handlecreatestructureSubmit = () => {
    navigate(`/coreservice/NoticeBoard-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  useEffect(()=>{
    GetData()
  },[])
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.NOTICE_BOARD_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  }
  // parseindicatordata function
  const parseIndicatorData = (data) => {

    let reportData = [];
    data &&
    data.forEach((notice, index) => {
        let row = {
          id: notice?.id,
          name: notice?.name,
          action: getIcons(notice?.id),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (code) => {
    return (
      <>
        <IconButton
          aria-label="Edit Notice"
          onClick={() => onClickUpdateData(code)}
        >
          <EditIcon />
        </IconButton>
        <IconButton
          aria-label="Delete Notice"
          onClick={() => onClickDeleteData(code)}
        >
          <DeleteIcon />
        </IconButton>
      </>
    );
  };
  // update function
  const onClickUpdateData = (code) => {
    navigate(`/coreservice/NoticeBoard-create/` + code);
  };
  // delete function
  const onClickDeleteData = (code) => {
    setConfirmationModalHeader("Notice");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setNoticeId(code);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setNoticeId("");
  };
  const handlePositiveResponse = async () => {
    const structureid = noticeId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Structure
    const res = await apiHandler({
      url: endpoint.NOTICE_BOARD_DELETE + noticeId,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Notice successfully deleted", true);
      GetData()  
    }
  };
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      return (
        row.name?.toLowerCase()?.includes(val?.toLowerCase()) 
      );
    });
    parseIndicatorData(filteredData);
  };
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label="Notice Board"
          button1="Create"
          button1click={handlecreatestructureSubmit}
          onSearchChange={onSearchChange}
          searchLabel = "Search For Notice Board"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <TableContainer component={Paper} elevation={0}>
          <ColumnGroupingTable
            columns={tableColumns}
            rows={selectedTableData}
          />
        </TableContainer>
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </GridContainer>
  );
};

export default NoticeBoard;
